import React from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';

import { BLACK, PRIMARY_PURPLE } from '../../../theme/colorConstants';
import { PRIMARY_FONT } from '../../../theme/fontConstants';
import { getId, toIds } from '../helpers';

import AsyncEntitySearch from './AsyncEntitySearch';

const chipSx = {
  backgroundColor: PRIMARY_PURPLE[20],
  border: `1px solid ${PRIMARY_PURPLE[30]}`,
  color: PRIMARY_PURPLE[80],
  fontFamily: PRIMARY_FONT[500],
  '& .MuiChip-deleteIcon': { color: PRIMARY_PURPLE[60], fontSize: '16px' },
};

const rootSx = { display: 'flex', flexDirection: 'column', gap: '12px' };

const chipsSx = { display: 'flex', flexWrap: 'wrap', gap: '8px' };

const helperTextSx = { color: BLACK[60], fontSize: '12px', marginTop: '-6px' };

const EntityChipsField = ({
  testId,
  entities = [],
  onSave,
  placeholder,
  route,
  buildRequestData,
  optionLabel = 'name',
  helperText,
}) => (
  <Box sx={rootSx}>
    {entities.length > 0 && (
      <Box sx={chipsSx}>
        {entities.map((entity) => (
          <Chip
            key={getId(entity)}
            label={entity[optionLabel]}
            onDelete={() => onSave(entities.filter((e) => getId(e) !== getId(entity)))}
            sx={chipSx}
          />
        ))}
      </Box>
    )}
    <AsyncEntitySearch
      testId={testId}
      placeholder={placeholder}
      route={route}
      buildRequestData={buildRequestData}
      optionLabel={optionLabel}
      excludeIds={toIds(entities)}
      onSelect={(entity) => onSave([...entities, entity])}
    />
    {helperText && <Typography sx={helperTextSx}>{helperText}</Typography>}
  </Box>
);

EntityChipsField.propTypes = {
  testId: PropTypes.string,
  entities: PropTypes.arrayOf(PropTypes.shape({})),
  onSave: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  route: PropTypes.string.isRequired,
  buildRequestData: PropTypes.func.isRequired,
  optionLabel: PropTypes.string,
  helperText: PropTypes.string,
};

export default EntityChipsField;
